// Lib
import React from 'react';
import { Typography } from '@mui/material';

// Components
import Address from './Address';

// Hooks
import useUI from '../../../../hooks/useUI';

// Constants
import { emptyImport } from '../../../../constants/addressBook';

// Styles
import { useStyles } from './AddressesStyles';

const Addresses = ({ addresses, setEditableAddress = () => {} }) => {
  const { classes } = useStyles();
  const { isTabletMode } = useUI();

  return (
    <div className={classes.root} data-testid="addresses-validation-block">
      {addresses.length ? (
        <>
          {!isTabletMode && (
            <div className={classes.headerContainer}>
              <Typography variant="h3">Entered Address</Typography>
              <Typography variant="h3">Validated Address</Typography>
            </div>
          )}
          {addresses.map((address) => (
            <Address
              key={address?.id}
              address={address}
              isTabletMode={isTabletMode}
              setEditableAddress={setEditableAddress}
            />
          ))}
        </>
      ) : (
        <div className={classes.emptyImport}>{emptyImport}</div>
      )}
    </div>
  );
};

export default Addresses;
